export default __webpack_public_path__ + "static/media/5396d4ed2b45878be296b63ab361d137.jpg";